import React, { useState, useEffect } from "react";
import { API_URL } from '../config';
import axios from 'axios';
import LoadingButton from "../components/LoadingButton";
import { useHeader } from "../contexts/HeaderContext";

const DriverSummaryPageB24 = () => {
  const [activeTab, setActiveTab] = useState("toZakalka");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { setHeaderExtras } = useHeader();

  // Состояния для вкладки "В пути к закалке"
  const [toZakalkaBatches, setToZakalkaBatches] = useState([]);

  // Состояния для вкладки "Обратный путь с закалки"
  const [fromZakalkaBatches, setFromZakalkaBatches] = useState([]);

  // Загрузка партий в пути к закалке
  const fetchToZakalkaBatches = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/driver-batches-to-zakalka`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        setToZakalkaBatches(response.data.batches);
      }
    } catch (err) {
      console.error("Ошибка загрузки партий к закалке:", err);
      setError(`Ошибка загрузки: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Загрузка партий в пути с закалки
  const fetchFromZakalkaBatches = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/driver-batches-from-zakalka`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        setFromZakalkaBatches(response.data.batches);
      }
    } catch (err) {
      console.error("Ошибка загрузки партий с закалки:", err);
      setError(`Ошибка загрузки: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Подтверждение доставки партии на закалку
  const handleConfirmToZakalkaDelivery = async (batchId) => {
    try {
      // Собираем обновленные количества из полей ввода
      const inputs = document.querySelectorAll(`[data-batch-id="${batchId}"] input[type="number"]`);
      const deliveredQuantities = {};
      inputs.forEach(input => {
        const glassType = input.dataset.glassType;
        const quantity = parseInt(input.value) || 0;
        deliveredQuantities[glassType] = quantity;
      });

      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/driver-confirm-delivery-to-zakalka`, {
        batchId,
        deliveredQuantities
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        alert('Доставка на закалку подтверждена!');
        await fetchToZakalkaBatches();
      }
    } catch (err) {
      console.error("Ошибка подтверждения доставки:", err);
      setError(`Ошибка подтверждения: ${err.message}`);
    }
  };

  // Подтверждение доставки партии с закалки
  const handleConfirmFromZakalkaDelivery = async (batchId) => {
    try {
      // Собираем обновленные количества из полей ввода
      const inputs = document.querySelectorAll(`[data-batch-id="${batchId}"] input[type="number"]`);
      const deliveredQuantities = {};
      inputs.forEach(input => {
        const glassType = input.dataset.glassType;
        const quantity = parseInt(input.value) || 0;
        deliveredQuantities[glassType] = quantity;
      });

      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/driver-confirm-delivery-from-zakalka`, {
        batchId,
        deliveredQuantities
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        alert('Доставка с закалки подтверждена!');
        await fetchFromZakalkaBatches();
      }
    } catch (err) {
      console.error("Ошибка подтверждения доставки:", err);
      setError(`Ошибка подтверждения: ${err.message}`);
    }
  };

  // Обработчик смены вкладки
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setError(null);

    if (tab === "toZakalka") {
      fetchToZakalkaBatches();
    } else if (tab === "fromZakalka") {
      fetchFromZakalkaBatches();
    }
  };

  // Вставка поиска и счётчика в хедер
  useEffect(() => {
    const batchCount = activeTab === "toZakalka" ? toZakalkaBatches.length : fromZakalkaBatches.length;
    setHeaderExtras(
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <input
          type="text"
          placeholder="Поиск по номеру, названию..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          style={{ width: "220px" }}
        />
        <span className="text-sm text-gray-600">
          Партий: <strong>{batchCount}</strong>
        </span>
      </div>
    );
    return () => setHeaderExtras(null);
  }, [searchQuery, toZakalkaBatches.length, fromZakalkaBatches.length, activeTab]);

  useEffect(() => {
    fetchToZakalkaBatches();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Управление доставкой</h1>

      {/* Вкладки */}
      <div className="mb-6 border-b border-gray-200">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <button
              className={`inline-block p-4 text-sm font-medium ${
                activeTab === "toZakalka"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => handleTabChange("toZakalka")}
            >
              🔥 В пути к закалке
            </button>
          </li>
          <li className="mr-2">
            <button
              className={`inline-block p-4 text-sm font-medium ${
                activeTab === "fromZakalka"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => handleTabChange("fromZakalka")}
            >
              📥 Обратный путь с закалки
            </button>
          </li>
        </ul>
      </div>

      {/* Отображение ошибок */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <strong>Ошибка:</strong> {error}
          <button
            onClick={() => setError(null)}
            className="ml-2 text-red-500 hover:text-red-700"
          >
            ✕
          </button>
        </div>
      )}

      {/* Контент вкладки "В пути к закалке" */}
      {activeTab === "toZakalka" && (
        <div>
          <h2 className="text-lg font-medium mb-4">Партии везу на закалку</h2>

          {loading ? (
            <div className="text-center py-4">Загрузка...</div>
          ) : (
            <div className="space-y-4">
              {toZakalkaBatches.map((batch) => (
                <div key={batch.id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h3 className="font-medium">🔥 Партия №{batch.id}</h3>
                      <p className="text-sm text-gray-600">{batch.orders?.length || 0} заказов</p>
                      <p className="text-xs text-gray-500">
                        Получено: {new Date(batch.receivedAt || Date.now()).toLocaleString('ru-RU')}
                      </p>
                    </div>
                    <LoadingButton
                      onClick={() => handleConfirmToZakalkaDelivery(batch.id)}
                      label="Доставил на закалку"
                      color="green"
                      className="text-sm"
                    />
                  </div>

                  <div className="border-t pt-3" data-batch-id={batch.id}>
                    <h4 className="text-sm font-medium mb-2">Стекло в партии (можно изменить количество):</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {Object.entries(batch.glassSummary || {}).map(([type, qty]) => (
                        <div key={type} className="text-sm bg-blue-50 rounded px-2 py-1 flex justify-between items-center">
                          <span className="font-medium">{type}:</span>
                          <input
                            type="number"
                            defaultValue={qty}
                            data-glass-type={type}
                            className="w-16 text-center border rounded"
                            min="0"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              {toZakalkaBatches.length === 0 && (
                <div className="text-center py-8 text-gray-500">
                  Нет партий для доставки на закалку
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Контент вкладки "Обратный путь с закалки" */}
      {activeTab === "fromZakalka" && (
        <div>
          <h2 className="text-lg font-medium mb-4">Партии везу с закалки</h2>

          {loading ? (
            <div className="text-center py-4">Загрузка...</div>
          ) : (
            <div className="space-y-4">
              {fromZakalkaBatches.map((batch) => (
                <div key={batch.id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h3 className="font-medium">📥 Партия №{batch.id}</h3>
                      <p className="text-sm text-gray-600">{batch.orders?.length || 0} заказов</p>
                      <p className="text-xs text-gray-500">
                        Получено с закалки: {new Date(batch.pickedUpAt || Date.now()).toLocaleString('ru-RU')}
                      </p>
                    </div>
                    <LoadingButton
                      onClick={() => handleConfirmFromZakalkaDelivery(batch.id)}
                      label="Доставил в цех"
                      color="blue"
                      className="text-sm"
                    />
                  </div>

                  <div className="border-t pt-3" data-batch-id={batch.id}>
                    <h4 className="text-sm font-medium mb-2">Готовое стекло (можно изменить количество):</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {Object.entries(batch.glassSummary || {}).map(([type, qty]) => (
                        <div key={type} className="text-sm bg-green-50 rounded px-2 py-1 flex justify-between items-center">
                          <span className="font-medium">{type}:</span>
                          <input
                            type="number"
                            defaultValue={qty}
                            data-glass-type={type}
                            className="w-16 text-center border rounded"
                            min="0"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              {fromZakalkaBatches.length === 0 && (
                <div className="text-center py-8 text-gray-500">
                  Нет готовых партий для доставки в цех
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DriverSummaryPageB24;
